import React, { FunctionComponent } from 'react'
import { Heading, Text } from '@afterpaytouch/core'
import { useTranslation } from '../../../../utils/convergence'
import styles from './style.module.css'
import { useCheckoutSizes } from '../../../../utils/responsive'

interface TimelineStep {
  label: string
  subtext?: string
}

export const NewToAfterpay: FunctionComponent = () => {
  const { t } = useTranslation(['educationIntro'])
  const { textSize, smallTextSize } = useCheckoutSizes()

  const steps: TimelineStep[] = [
    {
      label: t('newToAfterpay.steps.applyAccount'),
      subtext: t('newToAfterpay.steps.applyAccountSubtext'),
    },
    {
      label: t('newToAfterpay.steps.applyPayMonthly'),
      subtext: t('newToAfterpay.steps.applyPayMonthlySubtext'),
    },
  ]

  return (
    <div className={styles.container}>
      <div className={styles.contentWrapper}>
        <Heading size='L' renderAs='h2' className={styles.title}>
          {t('newToAfterpay.title')}
        </Heading>
      </div>
      <ol className={styles.timeline} data-testid='timeline-block'>
        {steps.map((step, index) => (
          <li key={step.label} className={styles.step} data-testid='timeline-item'>
            <span className={styles.marker} aria-hidden='true'>
              <span className={styles.dot} />
              {index < steps.length - 1 && <span className={styles.line} />}
            </span>
            <div className={styles.content}>
              <Text size={textSize} bold>
                {step.label}
              </Text>
              {step.subtext && (
                <Text size={smallTextSize} color='Gray40' className={styles.subtext}>
                  {step.subtext}
                </Text>
              )}
            </div>
          </li>
        ))}
      </ol>
    </div>
  )
}
